<div class="flex flex-col items-center justify-center w-full h-full page-wrap space-y-100-rem">
  <div class="flex size-font-weight-regular items-center justify-center error-icon">
    <img src="/svgs/global-error-icon.svg" alt="error icon" />
  </div>
  <h1 class="text-headline-sm-weight-semibold text-[1.25rem]">
    Something went wrong – Error {{ errorStatus() }}
  </h1>
  <p class="text-body-md-weight-regular text-[0.875rem] text-center w-md">
    Our servers are currently experiencing some problems. We are working to resolve the issue.
    Please try again in a few minutes.
  </p>

  <button mat-flat-button color="primary" (click)="refreshPage()">Refresh</button>
</div>
